import { $can, $hasFeature } from '@/core/utils/VueAcl'

export default {
  sectionName: 'LeftNavigation_CampaignsMenu',
  icon: 'navigation-campaigns',
  index: '3',
  isAllowed: () => $can('viewProjectItem'),
  subItems: [
    {
      sectionName: 'LeftNavigation_CreateCampaign',
      index: '3-1',
      isAllowed: () => $can('createProjectItem'),
      // @TODO: Remove after Campaign create release
      routeName: () =>
        $hasFeature('campaignLegacyUI') ? 'CreateCampaignOld' : 'CreateCampaign'
    },
    {
      sectionName: 'LeftNavigation_TemplateCampaigns',
      index: '3-2',
      isAllowed: () =>
        $hasFeature('campaignTemplates') && $can('createProjectItem'),
      routeName: 'TemplateCampaignsTab'
    },
    {
      sectionName: 'LeftNavigation_ApproveCampaign',
      index: '3-3',
      isAllowed: () => !$can('createProjectItem') && $can('sendPushCampaign'),
      routeName: 'ApproveCampaign'
    },
    {
      sectionName: 'LeftNavigation_Campaigns',
      index: '3-4',
      routeName: 'AllCampaignsTab',
      subRouteName: [
        'Campaigns',
        'ScheduledCampaignsTab',
        'LiveCampaignsTab',
        'PastCampaignsTab',
        'DraftCampaignsTab',
        'CampaignReport'
      ]
    },
    {
      sectionName: 'LeftNavigation_InboxFeed',
      index: '3-5',
      isAllowed: () => $hasFeature('inbox'),
      routeName: 'InboxFeed'
    },
    {
      sectionName: 'LeftNavigation_AdCampaigns',
      index: '3-6',
      isAllowed: () => $hasFeature('attributions'),
      routeName: 'AdCampaigns'
    },
    {
      sectionName: 'LeftNavigation_RedemptionCampaigns',
      index: '3-7',
      isAllowed: () => $hasFeature('redemptions'),
      routeName: 'RedemptionCampaigns'
    },
    {
      sectionName: 'LeftNavigation_EngagementCategories',
      index: '3-8',
      isAllowed: () => $can('viewProjectItem'),
      routeName: 'EngagementCategoriesTab',
      subRouteName: ['EngagementCategoriesPage']
    },
    {
      sectionName: 'LeftNavigation_NotificationsLog',
      index: '3-9',
      routeName: 'NotificationList',
      subRouteName: ['NotificationDetails']
    }
  ]
}



// WEBPACK FOOTER //
// ./src/common/components/navigation/navigation-section-items/campaign.js